if (!customElements.get('chronoera-hero-motion')) {
  customElements.define('chronoera-hero-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.abort || !this.querySelector('template')) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.playbackBlocked = false;
      this.inView = false;
      this.preference.addEventListener('change', () => this.sync(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.observer = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting;
        this.sync();
      }, { threshold: 0.12 });
      this.observer.observe(this);
    }
    setupVideo() {
      if (this.video) return;
      this.append(this.querySelector('template').content.cloneNode(true));
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.video.muted = true;
      this.video.loop = true;
      this.video.playsInline = true;
      const options = { signal: this.abort.signal };
      this.video.addEventListener('playing', () => {
        this.classList.add('has-motion');
      }, options);
      this.video.addEventListener('error', () => {
        this.classList.remove('has-motion');
      }, options);
    }
    sync() {
      if (this.preference.matches) {
        this.video?.pause();
        this.classList.remove('has-motion');
        return;
      }
      if (!this.inView || document.hidden || this.playbackBlocked) {
        this.video?.pause();
        return;
      }
      this.setupVideo();
      this.video?.play().catch(() => {
        this.classList.remove('has-motion');
        this.playbackBlocked = true;
      });
    }
    disconnectedCallback() {
      this.video?.pause();
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
      this.video?.remove();
      this.video = null;
      this.classList.remove('has-motion');
    }
  });
}

